import ReviewStatus from "@/helpers/review/ReviewStatus.js";
import {tr} from "@vue-components/helpers/I18nPluginHelper.js";

export default class PageChecker {
    constructor(cmsWebsite, cmsPage, lang) {
        this.cmsWebsite = cmsWebsite;
        this.cmsPage = cmsPage;
        this.languages = this.cmsWebsite.settings.languages;
        this.updateReview(lang);
    }

    updateReview(lang = `en`) {
        try {
            const date =  new Date();
            this.id = Math.random();
            this.components = [];
            this.pageErrors = [];
            this.errors = [];

            this.status = {
                label: `All good`,
                glyph: `fa-circle-check`,
                variant: `success`
            };
            this.stats = {
                errors: 0,
                warnings: 0,
                h1Count: 0,
                titles: 0,
                // TODO add paragraphs here
                words: 0,
                readTime: 0
            }
            this.SEO = {
                keywords: []
            }
            this.textContent = [];

            let keywordSpecs = [];
            if (this.cmsPage.specs.mainKeywords[lang]) {
                keywordSpecs = keywordSpecs.concat(this.cmsPage.specs.mainKeywords[lang]);
            }
            if (this.cmsPage.specs.keywords[lang]) {
                keywordSpecs = keywordSpecs.concat(this.cmsPage.specs.keywords[lang]);
            }

            for (let keywordSpec of keywordSpecs) {
                let keywords = keywordSpec.variations.concat(keywordSpec.keyword);
                const regexp = new RegExp(keywords.map(k =>
                    k.replace(/[.*+?^${}()|[\]\\]/g, `\\$&`)  // escape regex chars
                ).join(`|`), `gi`); // g = global, i = case-insensitive

                this.SEO.keywords.push({
                    label: keywordSpec.keyword,
                    variations: keywordSpec.variations,
                    min: keywordSpec.min,
                    max: keywordSpec.max,
                    count: 0,
                    regexp: regexp
                });
            }

            for (let block of this.cmsPage.blocks) {
                if (!block.isHiddenAll) {
                    this.components = this.components.concat(block.getComponents(`all`, true, true));
                }
            }
            for (let component of this.components) {
                this.errors = this.errors.concat(component.updateReview());
                if (component.type === `text`) {
                    if (component.preset === `h1`) {
                        this.stats.h1Count++;
                    }
                    if (component.preset.startsWith(`h`)) {
                        this.stats.titles++;
                    }

                    // use newText to take update before applying changes
                    const htmlText = component.newText[lang];

                    if (!htmlText)
                        continue;

                    this.textContent.push({
                        id: component.id,
                        content: htmlText,
                        tag: component.getComponentTag()
                    });
                    const text = this.extractText(htmlText);
                    this.stats.words += this.countWord(text)

                    for (let keyword of this.SEO.keywords) {
                        const matches = text.match(keyword.regexp);
                        if (matches) {
                            keyword.count += matches.length;
                        }
                    }
                }
            }

            this.stats.readTime = Math.max(1, Math.ceil(this.stats.words / 225));


            if (!this.cmsPage.meta.socialImage)
                this.pageErrors.push(new ReviewStatus(`error`, this.cmsPage, `Missing Page Meta Image`));
            if (!tr(this.cmsPage.meta.title))
                this.pageErrors.push(new ReviewStatus(`error`, this.cmsPage, `Missing Page Meta Title`));
            if (!tr(this.cmsPage.meta.description))
                this.pageErrors.push(new ReviewStatus(`error`, this.cmsPage, `Missing Page Meta Description`));

            if (this.stats.h1Count > 1)
                this.pageErrors.push(new ReviewStatus(`error`, this.cmsPage, `Too many h1 (${this.stats.h1Count})`));
            else if (this.stats.h1Count === 0)
                this.pageErrors.push(new ReviewStatus(`error`, this.cmsPage, `Missing h1 title`));

            this.errors = this.errors.concat(this.pageErrors);

            for (let error of this.errors) {
                if (error.status === `error`) {
                    this.stats.errors++;
                } else {
                    this.stats.warnings++;
                }
            }

            if (this.stats.errors > 0 || this.stats.warnings > 0) {
                this.status.label = `${this.stats.errors} errors found and ${this.stats.warnings} warnings`;
            }

            if (this.stats.errors > 0) {
                this.status.glyph = `fa-circle-xmark`;
                this.status.variant = `danger`;
            } else if (this.stats.warnings > 0) {
                this.status.glyph = `fa-circle-exclamation`;
                this.status.variant = `warning`;
            }

            // const delta = new Date() - date;
            // console.log(`Page checker took ${delta}ms`);
        } catch (error) {
            console.error(error);
        }
    }

    extractText(text) {
        if (!text) {
            return text;
        }
        if (text.startsWith(`<`)) {
            const element = document.createElement(`div`);
            element.innerHTML = text;
            return element.innerText;
        }
        return text;
    }

    countWord(text) {
        if (!text) {
            return 0;
        }
        if (text.startsWith(`<`)) {
            text = this.extractText(text);
        }
        return text.trim().split(/\s+/).length;
    }
}
